import React from 'react'
import {Select, message} from 'antd'
const Option = Select.Option
import Tools from '../tools/Tools'

export default class InstructTypeSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            instructTypeList:[],
            value:!Tools.isNull(props.value)?props.value:undefined
        }
        this.getInstructTypeList = this.getInstructTypeList.bind(this)
    }

    componentDidMount() {
        if(!Tools.isHasWholeEnum(this.props.platform)){
            this.getInstructTypeList()
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.value != this.state.value ) {
            this.setState({
                value:nextProps.value
            })
        }
    }

    getInstructTypeList() {
        let url = Tools.getApiUrl("taskInstructTypeEnum",this.props.platform)
        let that = this
        Tools.fetch(url,'GET',function (data) {
            if (data.code === 0) {
                that.setState({
                    instructTypeList:data.data
                })
            } else {
                message.error(data.message)
            }
        })
    }

    render() {
        const {instructTypeList, value} = this.state
        const {onChange,width,showAll,allowClear,platform} = this.props
        let instructOptions = Tools.isHasWholeEnum(platform)?Tools.getOptionsFromGlobalEnums("enums.cmdRoutine","select"): instructTypeList.map(function (item) {
            return <Option key={item.key} value={item.key}>{item.value}</Option>
        })

        return  <Select value={value} style={{width:width||240}} disabled={this.props.disabled}
                        allowClear={allowClear}
                        className="instruct_select"
                        placeholder={Strings.rs14387}
                        onChange={(value)=>{
                            this.setState({
                                value
                            })
                            onChange(value)
                        }}>
            {showAll?<Option key={''} value={''}>{Strings.rs10613}</Option>:null}
            {instructOptions}
        </Select>
    }

}